export * from './global-style';
